import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Backdrop, Box, Container, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import MenuUser from './components/MenuUser';
import NavBrand from './components/NavBrand';

// -------------- styled components -------------------

const NavbarWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  width: '100%',
  backgroundColor: theme.palette.grey[0],
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: '0px 2px 15px -7px rgba(0,0,0,0.5)',
  transition: 'top 0.5s',
  zIndex: 5,
}));

const NavbarContent = styled(Stack)(() => ({
  height: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

// ------------------- components -------------------------------

const NavbarExamPage = ({ logOut }) => {
  const { user } = useSelector((state) => state.auth);
  const { examTestData, questionNumber } = useSelector((state) => state.exam);
  const { title: examTitle, totalProblems } = examTestData;

  const [open, setOpen] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);

  const ExamProgress = Math.round(
    (Number(questionNumber) / totalProblems) * 100,
  );
  // close overlay/backdrop when clicked
  const handleCloseOverlay = () => {
    setOverlayOpen(!overlayOpen);
  };

  // hide navbar animation onScroll
  const handleScroll = () => {
    const fixedNavbar = document.getElementById('fixed-navbar');

    if (fixedNavbar && window.pageYOffset > 70) {
      fixedNavbar.style.top = '-70px';
    } else {
      fixedNavbar.style.top = '0px';
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <>
      <Backdrop
        open={overlayOpen}
        onClick={handleCloseOverlay}
        sx={{ zIndex: 4 }}
      />
      <NavbarWrapper id="fixed-navbar">
        <Container maxWidth="xl" sx={{ height: '100%' }}>
          <NavbarContent>
            <NavBrand title={examTitle ? `Exam - ${examTitle}` : ''} />

            {/* renders user menu if user has logged in */}
            {user.email ? (
              <MenuUser
                user={user}
                open={open}
                setOpen={setOpen}
                setOverlay={setOverlayOpen}
                logOut={logOut}
                isExamPage
                progress={ExamProgress}
                progressTitle="EXAM PROGRESS"
              />
            ) : null}
          </NavbarContent>
        </Container>
      </NavbarWrapper>
    </>
  );
};

export default NavbarExamPage;
